<lb-profile-info-box infoBoxIcon="untitled-ui/communication/mail-01" [formGroup]="form()">
	<ng-content right>
		@if (isGuest()) {
			<lb-form-row>
				<lb-form-field>
					<label>Personal Email</label>
					<input type="text" md-form-input formControlName="personalEmail" />
				</lb-form-field>

				<lb-form-field>
					<label>Phone Number</label>
					<input type="text" md-form-input formControlName="phoneNumber" />
				</lb-form-field>
			</lb-form-row>
		} @else {
			<lb-form-row>
				<lb-form-field>
					<label>LanguageBird Email</label>
					<input type="text" md-form-input formControlName="primaryEmail" />
				</lb-form-field>

				@if (isAdmin() || isSelf()) {
					<lb-form-field>
						<label>Personal Email</label>
						<input type="text" md-form-input formControlName="personalEmail" />
					</lb-form-field>
				}
			</lb-form-row>

			<lb-form-row>
				<lb-form-field class="phone-number">
					<label>Phone Number</label>
					<input type="text" md-form-input formControlName="phoneNumber" />
				</lb-form-field>
			</lb-form-row>
		}
	</ng-content>
</lb-profile-info-box>
